import { Component, OnInit } from '@angular/core';
import { IWidgetEditor, WidgetType } from "src/app/models/dashboard";
import { Widget } from 'src/api/models';
import { Dashboard } from 'src/api/models'

@Component({
  selector: 'app-new-line-widget-editor',
  templateUrl: './new-line-widget-editor.component.html',
  styleUrls: ['./new-line-widget-editor.component.css']
})
export class NewLineWidgetEditorComponent implements OnInit, IWidgetEditor {
  public widgetType: WidgetType;
  public widget: Widget;
  public dashboard: Dashboard;

  constructor() {}

  ngOnInit() {
    this.widget.size = 12;
  }

}
